import { getStorage } from "firebase/storage";
import firebase from "../../settings/firebase";

export default getStorage(firebase);
